class TextRotator {
  constructor(element, interval = 1500) {
    this.element = element;
    this.interval = interval;
    this.words = this.element.dataset.words.split(',').map(word => word.trim());
    this.colors = this.element.dataset.colors.split(',').map(color => color.trim());
    this.currentIndex = 0;
    this.init();
  }

  init() {
    if (this.words.length <= 1) return;
    // Set initial background color
    this.element.style.backgroundColor = this.colors[0];
    this.rotate();
    setInterval(() => this.rotate(), this.interval);
  }

  async rotate() {
    // Add fade-out class to current text
    this.element.classList.add('fade-out');
    
    // Wait for fade-out animation to complete
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // Update text and color, prepare for fade-in
    this.currentIndex = (this.currentIndex + 1) % this.words.length;
    this.element.textContent = this.words[this.currentIndex];
    this.element.style.backgroundColor = this.colors[this.currentIndex];
    this.element.classList.remove('fade-out');
    this.element.classList.add('fade-in');
    
    // Remove fade-in class after animation completes
    setTimeout(() => {
      this.element.classList.remove('fade-in');
    }, 500);
  }
}

// Initialize all rotating text elements
document.addEventListener('DOMContentLoaded', () => {
  const rotators = document.querySelectorAll('.js-rotate-text');
  rotators.forEach(element => new TextRotator(element));
}); 